
export enum FormMode {
  Create = 'create',
  Details = 'details',
  Edit = 'edit'
}
